import apifetch from "utils/apifetch";

export default async function getTenantName() {

    let response = await apifetch("account/gettenantname", {
        headers: new Headers({
            Accept: "application/json",
            "Content-Type": "application/json",
        }),
        method: "GET"
    });

    if (response.ok) {
        let responseData = await response.json();
        if (responseData) {
            return responseData.tenantName;
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./ClientApp/utils/getTenantName.ts